import React, { useState } from 'react';
import {
  Box,
  useTheme,
  TextField,
  InputAdornment,
  IconButton,
  Fab,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import { useIntl } from 'umi';
import SendIcon from '@material-ui/icons/Send';
import { Controller, useFormContext } from 'react-hook-form';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ModalML from '@/components/ModalML/NewModalML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import CouponModal from '../operate_modal/coupon_modal/index';
import NumberFormatML from '@/components/NumberFormatML';
import PeriodValidity from '../period_validity/PeriodValidity';
import FailureValidity from '../failure_validity/FailureValidity';
import CampaignEquityStyled from './CampaignEquityStyled';

//数字问题
const NumberFormatCustom = React.forwardRef((props, ref) => (
  <NumberFormatML {...props} allowNegative={false} ref={ref} />
));
const CampaignEquity = (props) => {
  //过于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  //人群类型

  const { register } = useFormContext();
  const {
    control,
    setCouponList,
    couponList,
    status,
    setContentValue,
    contentValue,
    // getValues,
  } = props;

  //是否发放优惠券
  // const [isCouponDelivery, setIsCouponDelivery] = useState();

  //调整内容radio

  const theme = useTheme();
  //打开优惠券模板
  const [open, setOpen] = useState();
  const handleCancel = () => {
    setOpen(false);
  };
  const onClose = () => {
    setOpen(false);
  };

  const handleSubmitSuccess = (selectList) => {
    setCouponsChooseItemShowIdData(selectList);
    setOpen(false);
    setCouponList(selectList);
  };
  //
  const handleSetting = () => {
    setOpen(true);
  };
  //删除优惠券
  const handleDeleteCouponItem = (id) => {
    if (status !== 'detail') {
      let selectedCouponList = [...couponList];
      let Index = -1;
      selectedCouponList.map((i, index) => {
        if (i.id === id) {
          Index = index;
        }
      });
      Index >= 0 && selectedCouponList.splice(Index, 1);
      setCouponList(selectedCouponList);
      setCouponsChooseItemShowIdData(selectedCouponList);
    }
  };
  // const { register } = useFormContext();

  const levelData = [
    {
      id: 5,
      name: '优惠券ID',
    },
    {
      id: 0,
      name: '优惠券名称',
    },
    {
      id: 1,
      name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl02' }),
    },
    {
      id: 2,
      name:
        formatMessage({ id: 'marketing.people.regnotcon.c02.lbl03' }) + '(张)',
    },
    {
      id: 3,
      name: '赠送数量',
    },
    {
      id: 4,
      name: formatMessage({ id: 'marketing.people.regnotcon.c02.lbl05' }),
    },
    // {
    //   id: 5,
    //   name: '状态',
    // },
  ];
  const [couponPage, setCouponPage] = useState(1);
  const [couponsChooseItemShowIdData, setCouponsChooseItemShowIdData] =
    useState([]); //可用选中的优惠券确定后的值Id

  //计算当前分页的列表
  const initDataTables = (list, page) => {
    const newList = list ?? [];
    const startPage = page > 1 ? (page - 1) * 9 : 0;
    const endPage = 9;
    const data = [...newList].splice(startPage, endPage);
    return data;
  };
  //计算总页数
  const initPageSize = (num) => {
    return Math.ceil(num / 9);
  };
  // 优惠券的分页上一页
  const handleCouponPrevious = () => {
    couponPage > 1 && setCouponPage(couponPage - 1);
  };
  // 优惠券的分页下一页
  const handleCouponDown = () => {
    couponsChooseItemShowIdData.length - couponPage * 9 > 0 &&
      setCouponPage(couponPage + 1);
  };
  // if()

  const handleContentChange = (e) => {
    setContentValue(e.target.value);
  };
  return (
    <CampaignEquityStyled theme={theme}>
      <Box display="flex" gap="49px" alignItems="center" marginBottom="32px">
        <Box fontSize="18px" color="#212121" fontWeight="600" lineHeight="25px">
          调整内容
        </Box>
        <Box>
          <Box>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={contentValue}
              onChange={handleContentChange}
            >
              <FormControlLabel
                value="COUPON"
                control={<Radio />}
                label="发放优惠券"
              />
              <FormControlLabel
                value="COUPON_BIND_TIME"
                control={<Radio />}
                label="优惠券有效期调整"
              />
              <FormControlLabel
                value="COUPON_BIND_STATUS"
                control={<Radio />}
                label="优惠券失效调整"
              />
            </RadioGroup>
          </Box>
        </Box>
      </Box>
      {status !== 'detail' && contentValue === 'COUPON' && (
        // <Box className="link" onClick={handleSetting}>
        //   <span className="red">*</span>
        //   {formatMessage({ id: 'marketing.people.regnotcon.n04.btn03' })}
        // </Box>
        <Fab
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={handleSetting}
          sx={{ fontSize: '13px' }}
        >
          <SendIcon
            sx={{ width: '24px', height: '24px', marginRight: '7px' }}
          />
          发放优惠券
        </Fab>
      )}

      {contentValue === 'COUPON' && (
        <Box mt={4}>
          <Box className="table">
            <Box className="table-title">
              {levelData &&
                levelData.map((title, i) => {
                  return (
                    <div key={i} className={i === 2 && 'subTitle'}>
                      {title.name}
                    </div>
                  );
                })}
            </Box>
            <Box className="table-content">
              {initDataTables(couponList, couponPage)?.map((item, index) => {
                return (
                  <Box className="table-row" key={index}>
                    <div className="coupon-id">{item?.id}</div>
                    <div className="coupon-title">{item?.title}</div>
                    <div className="subTitle">{item?.subTitle}</div>
                    <div className="surplus">{item?.surplus}</div>
                    <div className="action">
                      <div>
                        <SvgIconML
                          name="coupon"
                          size={18}
                          className="coupon"
                        ></SvgIconML>
                        <span className="coupon-num">
                          <Controller
                            register={register}
                            name={`givenNum${index}`}
                            variant="standard"
                            type="number"
                            disabled={status === 'detail'}
                            // required
                            placeholder=""
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  张
                                </InputAdornment>
                              ),
                            }}
                            render={(rp) => (
                              <TextField
                                name={`givenNum${index}`}
                                variant="standard"
                                register={register}
                                disabled={status === 'detail'}
                                // type="number"
                                value={item?.surplus > 0 ? item.givenNum : 0}
                                // required
                                placeholder={''}
                                InputProps={{
                                  inputComponent: NumberFormatCustom,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      张
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  if (
                                    (e.target.value && e.target.value < 1) ||
                                    (e.target.value > item?.surplus &&
                                      e.target.value < 9)
                                  ) {
                                    val = '';
                                  }
                                  if (
                                    e.target.value &&
                                    e.target.value > item?.surplus &&
                                    e.target.value >= 9
                                  ) {
                                    val = e.target.value.substr(
                                      0,
                                      e.target.value.length - 1,
                                    );
                                  }
                                  const currentCouponList = [];
                                  couponList.map((i) => {
                                    if (i.id === item.id) {
                                      i.givenNum = val;
                                      currentCouponList.push(i);
                                    } else {
                                      currentCouponList.push(i);
                                    }
                                    return currentCouponList;
                                  });
                                  setCouponList(currentCouponList);
                                  return rp.onChange(val);
                                }}
                              />
                            )}
                            control={control}
                            id="basic"
                            className="basic-name"
                            label=""
                            defaultValue={item?.surplus > 0 ? item.givenNum : 0}
                          />
                        </span>
                      </div>
                      {/* {(getValues(`givenNum${index}`) > item?.surplus ||
                        getValues(`givenNum${index}`) < 1) && (
                        <div style={{ color: '#f44336', fontSize: '12px' }}>
                          {getValues(`givenNum${index}`) < 1
                            ? '赠券数量不得小于1'
                            : '优惠券名称赠券数量大于库存'}
                        </div>
                      )} */}
                    </div>
                    <div className="delete">
                      <ButtonTip title="删除">
                        <IconButton
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          color="inherit"
                          disabled={status === 'detail'}
                          onClick={() => handleDeleteCouponItem(item.id)}
                        >
                          <SvgIconML
                            name="circleDelete"
                            size={24}
                            fill={
                              status === 'detail'
                                ? theme.palette.secondary.disabled
                                : theme.palette.primary.main
                            }
                            className="preview"
                          />
                        </IconButton>
                      </ButtonTip>
                    </div>
                  </Box>
                );
              })}
            </Box>
            {couponsChooseItemShowIdData.length > 0 && (
              <div className="Pagination">
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={3}
                >
                  <Box
                    sx={{
                      cursor: 'pointer',
                      color: couponPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                    onClick={() => {
                      handleCouponPrevious();
                    }}
                  >
                    上一页
                  </Box>
                  <Box color="#1565c0">第{couponPage}页</Box>
                  <Box
                    onClick={handleCouponDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        couponPage * 9 >= couponsChooseItemShowIdData?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box color="#1565c0">
                    共{initPageSize(couponsChooseItemShowIdData?.length || 0)}页
                  </Box>
                </Box>
              </div>
            )}
          </Box>
        </Box>
      )}
      {contentValue === 'COUPON_BIND_TIME' && (
        <Box>
          <Box
            fontSize="18px"
            color="#212121"
            fontWeight="600"
            lineHeight="25px"
            mt={1}
            marginBottom="5px"
          >
            选择优惠券
          </Box>
          <PeriodValidity />
        </Box>
      )}
      {contentValue === 'COUPON_BIND_STATUS' && (
        <Box>
          <Box
            fontSize="18px"
            color="#212121"
            fontWeight="600"
            lineHeight="25px"
            mt={1}
            marginBottom="4px"
          >
            选择优惠券
          </Box>
          <Box
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#212121',
              marginBottom: '-12px',
            }}
          >
            确认成功后选中的优惠券的状态将会被调整为“已失效”
          </Box>
          <FailureValidity />
        </Box>
      )}
      <ModalML
        open={open}
        setOpen={setOpen}
        onCancel={handleCancel}
        title={formatMessage({ id: 'marketing.people.regnotcon.d01.lbl02' })}
        onConfirm={handleSubmitSuccess}
        onClose={onClose}
      >
        <CouponModal
          open={open}
          control={control}
          setOpen={setOpen}
          onConfirm={handleSubmitSuccess}
          couponList={couponList}
        ></CouponModal>
      </ModalML>
    </CampaignEquityStyled>
  );
};
export default CampaignEquity;
